import * as React from 'react';
import type { SVGProps } from 'react';

const SvgWeekendIconHover = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={23} height={20} fill="none" {...props}>
    <path
      fill="#d04237"
      fillRule="evenodd"
      d="m12.802 19.194-1.549-4.403-1.448 4.387-.27.822H6.721l-.275-.816-5.916-17.6L0 .006h3.703l.272.823L8.128 13.44l1.238-3.754-2.869-8.087L5.931 0h3.66l.28.804 1.334 3.83 1.3-3.822.277-.812h3.627l-3.352 9.64 1.347 3.84L18.684 0h3.679l-6.234 19.167-.269.828h-2.777l-.281-.8ZM21.112.91h-1.763l-4.902 15.44-2.353-6.708L15.131.91h-1.698l-2.219 6.517L8.945.909H7.218l3.11 8.765-2.2 6.67L3.046.913H1.265l6.11 18.177h1.502l2.35-7.118 2.5 7.113H15.2L21.111.909Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgWeekendIconHover;
